import { EnumTagGroupType, EnumTagSuggestionEntityTypes } from "gql/generated";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useEntityOptions = () => {
  const { t } = useTranslation("adminland", {
    keyPrefix: "PAGE.TAG_MANAGER.FLYOUTS.COMMON_FORM",
  });
  const entityOptions = useMemo(
    () => [
      {
        label: t("LISTINGS"),
        value: EnumTagSuggestionEntityTypes.Operator,
        types: [
          EnumTagGroupType.Global,
          EnumTagGroupType.Amenity,
          EnumTagGroupType.BusinessType,
          EnumTagGroupType.OrganizationSpecific,
        ],
      },
      {
        label: t("EVENTS"),
        value: EnumTagSuggestionEntityTypes.Event,
        types: [
          EnumTagGroupType.GlobalEvent,
          EnumTagGroupType.OrganizationSpecific,
        ],
      },
      {
        label: t("PROMOTIONS"),
        value: EnumTagSuggestionEntityTypes.Promotion,
        types: [EnumTagGroupType.OrganizationSpecific],
      },
      {
        label: t("PEOPLE"),
        value: EnumTagSuggestionEntityTypes.Person,
        types: [EnumTagGroupType.OrganizationSpecific],
      },
    ],
    [t],
  );

  return {
    entityOptions,
  };
};
